
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lojas",
      function () {
        return require("private-next-pages/lojas.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lojas"])
      });
    }
  